import { useIntl } from 'react-intl';

import { emailRule } from 'utils/forms';

import BRFormInputs from 'components/BRFormInputs/BRFormInputs';

import './BasicInfoSection.less';

const BasicInfoSection = ({ formRef, isUsedEmail, isUsedName, isEdit }) => {
  const { formatMessage } = useIntl();

  return (
    <div className="br-basic-info-section br-create-edit-page-card">
      <div className="br-create-edit-page-card__title">
        {formatMessage({
          id: 'team_members.create_edit_member.basic_info_section.title'
        })}
      </div>
      <div className="br-basic-info-section__content">
        <BRFormInputs
          formRef={formRef}
          name="email"
          inputTitle={formatMessage({
            id: 'team_members.create_edit_member.form.email.label'
          })}
          placeholder={formatMessage({
            id: 'team_members.create_edit_member.form.email.placeholder'
          })}
          rules={[
            {
              required: true,
              whitespace: true,
              message: formatMessage({
                id: 'team_members.create_edit_member.form.email.error_msgs.required'
              })
            },
            emailRule(
              formatMessage({
                id: 'team_members.create_edit_member.form.email.error_msgs.not_valid'
              })
            )
          ]}
          {...(isUsedEmail && {
            validateStatus: 'error',
            help: formatMessage({
              id: 'team_members.create_edit_member.form.email.error_msgs.used'
            })
          })}
          subtitle={formatMessage({
            id: `team_members.create_edit_member.form.email.${
              isEdit ? 'edit_member_hint' : 'create_member_hint'
            }`
          })}
          disabled={isEdit}
          showSubTittle
          hasFeedback
        />
        <BRFormInputs
          formRef={formRef}
          name="name"
          inputTitle={formatMessage({
            id: 'team_members.create_edit_member.form.name.label'
          })}
          placeholder={formatMessage({
            id: 'team_members.create_edit_member.form.name.placeholder'
          })}
          rules={[
            {
              required: true,
              whitespace: true,
              message: formatMessage({
                id: 'team_members.create_edit_member.form.name.error_msgs.required'
              })
            }
          ]}
          {...(isUsedName && {
            validateStatus: 'error',
            help: formatMessage({
              id: 'team_members.create_edit_member.form.name.error_msgs.used'
            })
          })}
          hasFeedback
        />
      </div>
    </div>
  );
};

export default BasicInfoSection;
